export default __webpack_public_path__ + "static/media/Himanshu Khatri.06880e6a.jpg";